import React, { useEffect, useRef } from "react";
import PP from "../PP/PP";
import TOU from "../TOU/TOU";

import "./VideoModal.css";

const VideoModal = ({
  show,
  close,
  sku,
  notHostedLink,
  isHosted,
  hostedPath,
  thumbnailImg,
  isVideo,
  pp,
  tou,
}) => {
  const imgPath = process.env.REACT_APP_PUBLICRATES_URL + thumbnailImg;
  const videoPath = process.env.REACT_APP_VIDEO_URL + hostedPath;
  const modalContentRef = useRef(null); // ref for scroll to top

  useEffect(() => {
    if (show && modalContentRef.current) {
      // Scroll the modal content to the top
      modalContentRef.current.scrollTop = 0;
    }
  }, [show]);

  if (!show) return null;

  const renderContent = () => {
    if (isVideo === true || isVideo === "True") {
      return (
        <div
          className={
            isVideo !== "False" ? "modal-body-cust" : "modal-body-cust-pdf"
          }
          ref={modalContentRef}
        >
          {isHosted === "True" ? (
            <video
              key={videoPath}
              controls
              autoPlay
              className="modal-video-mod"
              poster={imgPath}
            >
              <source src={videoPath} type="video/mp4" />
              <source src={videoPath} type="video/ogg" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <iframe
              src={notHostedLink}
              height="100%"
              width="100%"
              title="description"
            />
          )}
        </div>
      );
    }

    if (isVideo === false || isVideo === "False") {
      return (
        <div
          className={
            isVideo !== "False" ? "modal-body-cust" : "modal-body-cust-pdf"
          }
          ref={modalContentRef}
        >
          <iframe
            src={notHostedLink}
            height="100%"
            width="100%"
            title="description"
          />
        </div>
      );
    }

    if (pp === true) {
      return (
        <div className="p-5" ref={modalContentRef}>
          <PP />
        </div>
      );
    }

    if (tou === true) {
      return (
        <div className="p-5" ref={modalContentRef}>
          <TOU />
        </div>
      );
    }
  };

  return (
    <>
      <div id="myModal" className={show ? "modal-show" : "modal-hide"}>
        <div
          className={
            isVideo !== "False"
              ? "modal-content-cust"
              : "modal-content-cust-pdf"
          }
        >
          <div className="modal-header-cust">
            <span className="modal-close-cust" onClick={close}>
              &times;
            </span>
          </div>
          {renderContent()}
          {pp === true || tou === true ? (
            <div className="p-3 border-t flex justify-end">
              <button
                className="inline-block font-normal leading-6 text-white text-center no-underline align-middle cursor-pointer select-none bg-[#c39f5c] border border-[#c39f5c] px-6 py-4 text-sm rounded-none transition-colors transition-shadow transition-border duration-150 ease-in-out uppercase tracking-widest"
                onClick={close}
              >
                Close
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default VideoModal;
